export default __webpack_public_path__ + "static/029-76ee31d56a49b75faa009a5cd05564f2.png";